/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-02-17 09:36:34
 **/

import NetworkInterface, { Packet, PublishOptions } from "@/network/NetworkInterface";

export default class Network extends NetworkInterface {
	static #instance: Network;
	public static get instance() {
		if (!Network.#instance) {
			Network.#instance = new Network();
		}
		return Network.#instance;
	}

	private constructor() {
		super();
	}

	#engine: NetworkInterface | null = null;

	public get engine() {
		if (!this.#engine) {
			throw new Error("No engine");
		}
		return this.#engine;
	}

	public set engine(engine: NetworkInterface) {
		this.#engine = engine;
	}

	public get is_connected(): boolean {
		try {
			return this.engine.is_connected;
		} catch {
			return false;
		}
	}

	public get topics(): string[] {
		return this.engine.topics;
	}

	public set topics(topics: string[]) {
		this.engine.topics = topics;
	}

	public connect(): Promise<NetworkInterface> {
		return this.engine.connect();
	}

	public disconnect(): Promise<void> {
		return this.engine.disconnect();
	}

	public subscribe(topic: string | string[]) {
		return this.engine.subscribe(topic);
	}

	public unsubscribe(topic: string | string[]) {
		return this.engine.unsubscribe(topic);
	}

	public publish<T = any>(topic: string, payload: T, options?: PublishOptions | null): Promise<Packet<T>> {
		return this.engine.publish(topic, payload, options);
	}
}
